import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLogIn = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-log-in" data-icon="icon-log-in" aria-hidden="true" {...props} ref={ref}><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>);
});

IconLogIn.displayName = 'IconLogIn';
